import { print } from "graphql";
import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map } from "rxjs/operators";
import { Linha } from "@/models/linha";

const linha = require("@/query/linhas-regulares/Linha.graphql");

export class LinhaAPI extends BaseAPI<Linha> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/linhas-regulares`;
  }

  public findBy(
    origem: number,
    destino: number,
    recaptcha: string
  ): AxiosObservable<Linha[]> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(linha),
        variables: {
          inputLinha: {
            idOrigem: origem,
            idDestino: destino,
            recaptcha: recaptcha,
          },
          inputPage: {
            page: 0,
            size: 50,
          },
        },
      })
      .pipe(
        map((data: any) => {
          const { linhas } = data;

          return linhas.map(
            (linha: any) =>
              new Linha(
                linha.id,
                linha.linha,
                linha.transportadora,
                linha.servico,
                linha.codigoLinha,
                linha.itinerario,
                linha.origem,
                linha.destino,
                linha.tarifa,
                linha.temHorario
              )
          );
        })
      );
  }
}
